import React from 'react';

const IconFacebook = () => {
  return (
    <div>
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_175_639)">
          <path
            d="M40.8285 20C40.8285 8.95431 31.8742 0 20.8285 0C9.78277 0 0.828461 8.95431 0.828461 20C0.828461 29.9826 8.14217 38.2567 17.7035 39.7571V25.7813H12.6254V20H17.7035V15.5938C17.7035 10.5813 20.6893 7.81252 25.2578 7.81252C27.446 7.81252 29.7348 8.20314 29.7348 8.20314V13.125H27.2128C24.7283 13.125 23.9535 14.6667 23.9535 16.2484V20H29.5004L28.6137 25.7813H23.9535V39.7571C33.5148 38.2567 40.8285 29.9826 40.8285 20Z"
            fill="black"
          />
          <path
            d="M28.6136 25.7813L29.5004 20H23.9535V16.2483C23.9535 14.6667 24.7283 13.125 27.2128 13.125H29.7347V8.20312C29.7347 8.20312 27.4459 7.8125 25.2578 7.8125C20.6893 7.8125 17.7035 10.5812 17.7035 15.5938V20H12.6253V25.7813H17.7035V39.7571C18.7372 39.9191 19.7821 40.0003 20.8285 40C21.8916 40 22.9352 39.9168 23.9535 39.7571V25.7813H28.6136Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_175_639">
            <rect
              width="40"
              height="40"
              fill="white"
              transform="translate(0.828461)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default IconFacebook;
